import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import AuthenticMexicoFood from "./sections/AuthenticMexicoFood";
import ServingSince2005 from "./sections/ServingSince2005";
import Gallery from "./sections/Gallery";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <HeroSection />
      <AuthenticMexicoFood />
      <ServingSince2005 />
      <Gallery />
      <Footer />
    </div>;
}